import {IDischargeNorm} from '../../api/api.types';
import {IHydrodataTimeseries} from '../../hydromet/timeseries/timeseries.controller';
import {ITranslateService} from 'angular-translate';
import * as moment from 'moment';

export interface ITimeseriesService {
	dischargeNormToDischargeTimeseries(dischargeNorm: IDischargeNorm): IHydrodataTimeseries;
}

export default class TimeseriesService {
	static readonly $inject = ['$translate'];

	constructor (private $translate: ITranslateService) {

	}

	dischargeNormToDischargeTimeseries(dischargeNorm: IDischargeNorm): IHydrodataTimeseries {
	  return {
	    data: dischargeNorm.normData.map((datum, index) => {
	      const month = Math.floor(index / 3);
	      const year = month >= 9 ? moment().year() - 1 : moment().year();
	      return {
	        hydrodata: datum,
	        date: moment()
	            .year(year)
	            .month(month)
	            .date((index % 3) * 10 + 5)
	            .startOf('day')
	      };
	    }).sort((datumA, datumB) => {
	      if (datumA.date.isBefore(datumB.date)) {
	        return -1;
	      } else if (datumA.date.isAfter(datumB.date)) {
	        return 1;
	      }
	      return 0;
	    }),
	    label: this.$translate.instant('HISTORICAL_NORM'),
	    highlighted: true
	  };
	}
}


/** WEBPACK FOOTER **
 ** ./app/station/timeseries/timeseries.service.ts
 **/